import React from 'react';
import PropTypes from 'prop-types';

const Blur = ({ children, intensity, enabled = false }) => {
    const blurStyle = enabled === false ? {} : {
        filter: `blur(${intensity}px)`,
        display: 'inline-flex',
        transition: 'filter 0.3s ease-in-out',        
    };

    return <span style={blurStyle} >{children}</span>;
};

Blur.propTypes = {
    children: PropTypes.node.isRequired,
    intensity: PropTypes.number,
};

Blur.defaultProps = {
    intensity: 5, // Default blur intensity
};

export default Blur;